{
  "activities": {
    "accessoryProvider": "Fornitore di Accessori",
    "accessoryRawMaterialProvider": "Fornitore di Materie Prime",
    "apparel": {
      "duvet": {
        "baffle": "Bordo",
        "farm": "Allevamento",
        "materialProduction": "Materia Prima",
        "preProcessor": "Pre-Processore"
      },
      "fabric": {
        "appret": "Finitura",
        "coating": "Rivestimento",
        "dyeing": "Tintura/Stampa",
        "lamination": "Laminazione",
        "materialProduction": "Materia Prima",
        "spinning": "Filatura",
        "weavingKnitting": "Tessitura/Maglieria"
      },
      "leather": {
        "appret": "Finitura",
        "dyeing": "Tintura",
        "farm": "Fattoria",
        "materialProduction": "Macello",
        "tanning": "Conciatura"
      },
      "manufacturing": "Produttore",
      "yarn": {
        "dyeing": "Tintura",
        "materialProduction": "Materia Prima",
        "spinning": "Filatura"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entità certificata",
    "footwear": {
      "assembling": "Assemblaggio",
      "finishing": "Finitura",
      "stitching": "Cucitura"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Assemblaggio",
      "bleaching": "Sbiancamento",
      "chemicalTreatment": "Trattamento chimico",
      "laminating": "Laminazione",
      "manufacturing": "Produzione",
      "pressing": "Pressatura",
      "printing": "Stampa",
      "resineRemoving": "Rimozione resina",
      "whiteWashing": "Lavaggio in bianco"
    },
    "product": {
      "productWashing": "Lavaggio prodotto",
      "washing": "Lavaggio"
    },
    "wood": {
      "assembling": "Assemblaggio",
      "brushing": "Spazzolatura",
      "calibrationAndCollage": "Calibrazione e collage",
      "harvesting": "Raccolta",
      "manufacturing": "Produzione",
      "materialDrying": "Essiccazione",
      "materialPeeking": "Selezione",
      "materialPeeling": "Pelatura",
      "materialSawing": "Taglio",
      "sanding": "Levigatura"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Seleziona solo i vuoti"
    },
    "applyButton": "Applica {{type}} a {{ itemCount }} elementi",
    "batchUpdateSuccess": "Aggiornamento riuscito",
    "batchUpdateSuccessMessage_one": "1 richiesta di informazione è stata aggiornata",
    "batchUpdateSuccessMessage_many": "{{count}} richieste di informazione sono state aggiornate",
    "batchUpdateSuccessMessage_other": "{{count}} richieste di informazione sono state aggiornate",
    "info": "Ci sono <b>{{count}}</b> altri elementi con l'attività <b><activity/><b>",
    "labels": {
      "certificate": "Certificato",
      "clientName": "Nome del cliente",
      "componentName": "nome del componente",
      "componentReference": "Riferimento del componente",
      "contact": "Contatto",
      "documentProof": "Certificato di campo",
      "informationRequestItemReference": "Riferimento della richiesta",
      "informationRequestItemReferenceHint": "Questo si riferisce al riferimento dell'elemento a cui è associata la richiesta di informazioni (ad esempio, il riferimento del prodotto, materiale o componente)",
      "materialName": "nome del materiale",
      "materialProportion": "Proporzione del materiale",
      "materialReference": "Riferimento del materiale",
      "productCollection": "Collezione di prodotti",
      "productColor": "Colore del prodotto",
      "productId": "ID del prodotto",
      "productionSite": "Sito di produzione",
      "productName": "Nome del prodotto",
      "productReference": "Riferimento del prodotto",
      "purchaseOrder": "Ordine di acquisto",
      "purchaseOrderRef": "Riferimento dell'ordine",
      "reference": "Riferimento"
    },
    "noDocument": "Nessun documento",
    "searchProduct": "Cerca prodotto",
    "title": "Applicare questa azione a più elementi?"
  },
  "batchPopover": {
    "button": "Aggiornamento Batch...",
    "certificateText": "Applicare questo certificato a più richieste?",
    "text": "Applicare questa {{key}} a diversi <b> <activity /> </b>?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Certificato",
      "products": "Prodotti",
      "type": "Tipo"
    },
    "success_one": "{{count}} richiesta di certificato aggiornata con successo",
    "success_many": "{{count}} richieste di certificato aggiornate con successo",
    "success_other": "{{count}} richieste di certificato aggiornate con successo"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Accettato",
    "OPENED": "Aperto",
    "REJECTED": "Rifiutato",
    "SUBMITTED": "In attesa"
  },
  "certificates": {
    "actions": {
      "delete": "Elimina",
      "submit": "Invia",
      "transfer": "Trasferire"
    },
    "activityName": "Passo di tracciabilità:",
    "labels": {
      "maxIssueDate": "Data di creazione massima",
      "purchaseOrder": "Ordine di acquisto o numero di fattura associato"
    },
    "modal": {
      "areyousure": "Sei sicuro di voler eliminare questo certificato (questa azione è irreversibile)?",
      "no": "No",
      "yes": "Sì, Elimina"
    },
    "noRequests": {
      "closed": "Nessuna richiesta di certificato completata",
      "open": "Nessuna richiesta di certificato in sospeso"
    },
    "productionSite": "Sito di produzione",
    "productionSitePending": "Informazioni del sito di produzione in sospeso",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Nascondi prodotti",
        "seeMore": "Mostra prodotti"
      },
      "productReferences": "Riferimenti del Prodotto"
    },
    "reference": "Riferimento: {{reference}}",
    "select": {
      "placeholder": "Seleziona un documento dai tuoi caricamenti."
    },
    "upload": {
      "title": "Caricare certificato"
    }
  },
  "contactModal": {
    "businessPartnerRepository": {
      "addressUnavailable": "Indirizzo non disponibile",
      "createNewOption": "Crea nuovo: \"{{term}}\"",
      "prefillLoadError": "Impossibile caricare i dettagli dell'azienda dall'anagrafica. Puoi comunque modificare il modulo manualmente.",
      "prefillLoadErrorTitle": "Precompilazione non disponibile"
    },
    "labels": {
      "companyCity": "companyCity",
      "companyCityPlaceholder": "Parigi",
      "companyCityTooltip": "Città dell'azienda",
      "companyCountry": "Paese",
      "companyCountryTooltip": "Paese dell'azienda",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "Nome dell'azienda",
      "companyNamePlaceholder": "Nome dell'azienda",
      "companyNameTooltip": "Nome pubblico dell'azienda",
      "companyPostalCode": "Codice postale dell'azienda",
      "companyPostalCodePlaceholder": "75001",
      "companyPostalCodeTooltip": "Codice postale dell'azienda",
      "companyRegistrationId": "Company registration ID",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "Numero di identificazione fiscale, CIN, GSTIN, USC, etc.",
      "companyRelationshipType": {
        "AGENT": "Agente",
        "BRAND": "Marca",
        "MANUFACTURER": "Produttore",
        "OTHER": "Altro",
        "RAW_MATERIAL_SUPPLIER": "Fornitore di materie prime",
        "SUPPLIER": "Fornitore",
        "TRADER": "Commerciante"
      },
      "companyRelationshipTypeName": "Tipo",
      "companyRelationshipTypeTooltip": "Natura dell'azienda partner, utilizzata per identificare il suo ruolo nella catena di approvvigionamento.",
      "companyStreet": "companyStreet",
      "companyStreetPlaceholder": "1 rue de Rivoli",
      "companyStreetTooltip": "Via dell'azienda",
      "companySupplierCode": "Codice fornitore",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Short internal identification code for the business partner.",
      "contactInformation": "contactInformation",
      "coordinates": "coordinates",
      "coordinatesPlaceholder": "coordinatesPlaceholder",
      "email": "Indirizzo email",
      "emailPlaceholder": "johndoe@gmail.com",
      "emailTooltip": "Indirizzo email utilizzato per contattare l'azienda partner.",
      "name": "Nome",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Identificazione usata per scambi via email.",
      "preferredLanguage": "Lingua preferita",
      "tags": "Tags",
      "tagsPlaceholder": "Aggiungi tags...",
      "tagsTooltip": "Classificazione interna, valutazione o qualsiasi altra informazione contestuale."
    },
    "messages": {
      "create": {
        "error": "error",
        "success": "success"
      },
      "update": {
        "success": "success"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "Aggiungi un nuovo contatto",
      "contact": "Contatto",
      "you": "tu"
    },
    "placeholders": {
      "contact": "Cerca un contatto"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Attività",
        "tooltip": "Ultimo login registrato dal partner."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} giorno",
        "averageResponseTimeValue_many": "averageResponseTimeValue",
        "averageResponseTimeValue_other": "{{nbDays}} giorni",
        "name": "Tempo medio di risposta",
        "tooltip": "Tempo medio preso per rispondere alle richieste di informazioni."
      },
      "certificateRequests": {
        "name": "Richieste di certificati"
      },
      "code": {
        "name": "Codice",
        "tooltip": "Codice di identificazione interno breve per il partner commerciale."
      },
      "company": {
        "name": "Azienda",
        "tooltip": "Nome pubblico ufficiale dell'azienda partner commerciale."
      },
      "contactEmail": {
        "name": "Contatto (email)",
        "tooltip": "Email del contatto principale all'interno dell'azienda partner."
      },
      "contactName": {
        "name": "Contatto (nome)",
        "tooltip": "Nome del contatto principale all'interno dell'azienda partner."
      },
      "location": {
        "name": "Posizione",
        "tooltip": "Paese dell'azienda partner commerciale"
      },
      "productionSiteRequests": {
        "name": "Richieste di siti di produzione",
        "received": "ricevute"
      },
      "productionSites": {
        "name": "Siti di produzione",
        "tooltip": "Conteggio dei siti dichiarati dal partner commerciale e conteggio dei paesi distinti."
      },
      "productRequests": {
        "name": "Richieste di prodotti"
      },
      "reminder": {
        "name": "Recordatorio",
        "tooltip": "Ultimo recordatorio inviato al partner."
      },
      "requests": {
        "name": "Richieste",
        "tooltip": "Richieste risposte dal partner."
      },
      "status": {
        "name": "Stato",
        "tooltip": "Identifica i partner commerciali attualmente attivi e disponibili per il commercio."
      },
      "tags": {
        "name": "Tag",
        "tooltip": "Classificazione interna, valutazione o qualsiasi altra informazione contestuale."
      },
      "type": {
        "name": "Tipo",
        "tooltip": "Natura dell'azienda partner utilizzata per identificare il suo ruolo nella catena di approvvigionamento."
      }
    },
    "status": {
      "active": "Attivo",
      "inactive": "Inattivo"
    }
  },
  "customFields": {
    "attachment": "Allegato",
    "updateCustomField": {
      "customField": {
        "message": "Il valore del campo personalizzato è stato aggiornato e inviato al cliente",
        "title": "Valore del campo personalizzato aggiornato"
      },
      "customFieldProof": {
        "message": "Il certificato del campo personalizzato è stato inviato",
        "title": "Certificato del campo personalizzato inviato"
      }
    },
    "uploadCustomFieldProofTooltip": "Richiedi un certificato digitale per supportare il valore dichiarato"
  },
  "deselectAll": "Deseleziona Tutti",
  "errors": {
    "axiosMessage": "Si è verificato il seguente errore: {{message}} \n\n per favore, riprova o contatta support@traceforgood.com se l'errore persiste",
    "reinforcedTraceability": "Non puoi assegnarti a questa richiesta, per favore trasferiscila alla persona appropriata",
    "title": "Si è verificato un errore"
  },
  "filters": {
    "client": "Cliente",
    "search": "Cerca",
    "status": {
      "canceled": "Annullato",
      "closed": "Chiuso",
      "opened": "Aperto",
      "placeholder": "Stato"
    },
    "title": "Filtri",
    "type": "Tipo"
  },
  "item": {
    "brand": "Marca",
    "client": "Cliente",
    "collection": "Collezione",
    "color": "Colore",
    "component": "Componente",
    "date": "Data",
    "marketLaunchDate": "Data di Lancio",
    "material_one": "Materiale",
    "material_other": "Materiali",
    "name": "Nome",
    "partOf": "Parte di",
    "product": "Prodotto",
    "purchaseOrderRef": "Numero Ordine",
    "reference": "Riferimento",
    "type": "Tipo"
  },
  "itemType": {
    "component": "Componente",
    "material": "Materiale",
    "product": "Prodotto"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "button",
        "no": "no",
        "title": "title",
        "yes": "yes"
      },
      "close": {
        "button": "button"
      },
      "eligibleProducts": {
        "checkbox": "checkbox",
        "error": {
          "title": "title"
        },
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "multiple",
            "none": "none",
            "single": "single"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "description",
          "title": "title"
        }
      },
      "header": {
        "description": {
          "default": "default",
          "noTraceabilityCampaign": "noTraceabilityCampaign",
          "runningJob": "runningJob"
        },
        "title": "title"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        }
      },
      "success": {
        "button": "button",
        "description": "description",
        "title": "title"
      }
    }
  },
  "maxError": "Deve essere minore o uguale a {{max}}",
  "minError": "Deve essere maggiore o uguale a {{min}}",
  "operation": {
    "component": "Componente",
    "duplicateProductionSite": "Si bien la presentación sigue siendo posible, ten en cuenta que se han declarado otros pasos en este sitio.",
    "material": "Materiale",
    "notOwner": "Le informazioni sono già state fornite da: {{email}}",
    "product": "Prodotto",
    "purchaseOrderRef": "Riferimento Ordine",
    "reference": "Riferimento {{type}} per il tuo fornitore",
    "unknown": "un altro contatto"
  },
  "operationNotCreated": "Si è verificato un errore",
  "operationNotCreatedMessage": "La richiesta di informazioni per questa richiesta non è stata creata ancora, per favore contatta il supporto a support@traceforgood.com",
  "prodsiterequest": {
    "actions": {
      "transfer": "Trasferire a un altro contatto",
      "transferAll": "Trasferisci tutto"
    },
    "noRequests": {
      "closed": "Non hai richieste completate.",
      "open": "Non hai richieste in sospeso."
    },
    "status": {
      "INVALID": "Incompleto",
      "TOBESUBMITTED": "Pronto per l'invio"
    },
    "transferModal": {
      "success_one": "{{count}} valore della richiesta del sito di produzione trasferito con successo",
      "success_many": "{{count}} valori della richiesta del sito di produzione trasferiti con successo",
      "success_other": "{{count}} valori della richiesta del sito di produzione trasferiti con successo",
      "title": "Richiesta di trasferimento del sito di produzione",
      "transferButton": "Trasferisci"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Aggiungi un nuovo sito di produzione",
      "productionSite": "Sito di Produzione"
    },
    "placeholders": {
      "productionSite": "Cerca un sito di produzione"
    }
  },
  "reopenRequest": {
    "error": "Impossibile riaprire la richiesta",
    "feedback_one": "{{count}} sotto-richiesta annullata",
    "feedback_many": "feedback",
    "feedback_other": "{{count}} sotto-richieste annullate",
    "title": "Sei sicuro di voler riaprire questa richiesta? (questa azione cancellerà tutte le sotto-richieste di questa richiesta)",
    "yes": "Sì, sono sicuro!"
  },
  "request": {
    "complete": "Finalizzare",
    "completeTooltip": "Fai clic qui per completare e chiudere la richiesta. Eventuali sotto-richieste trasferite saranno inoltrate al destinatario assegnato.",
    "errors": {
      "generic": "Si è verificato un errore. Riprova più tardi."
    },
    "incomplete": "Incompleto",
    "labels": {
      "composition": "Composizione",
      "requestDate": "Data della richiesta"
    },
    "readyToSubmit": "Pronto per invio",
    "seeLess": "Nascondi richiesta",
    "seeMore": "Mostra richiesta"
  },
  "requests": {
    "noRequests": {
      "closed": "Non hai chiuso ancora nessuna richiesta.",
      "open": "Non hai richieste in sospeso in attesa della tua azione."
    },
    "tabs": {
      "canceled": "canceled",
      "certificates": {
        "scope": "Certificati di Ambito",
        "transaction": "Certificati di Transazione"
      },
      "closed": "Completati",
      "prodsitefield": "Richiesta Sito di Produzione",
      "traceability": "Richieste di Tracciabilità"
    }
  },
  "requiredError": "Campo Obbligatorio",
  "selectAll": "Seleziona Tutto",
  "sorts": {
    "client": "client",
    "dueDate": "Data di scadenza",
    "orderDate": "Data di ordine",
    "receptionDate": "Data di ricezione della richiesta",
    "reference": "Riferimento"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Caricato",
    "REJECTED": "",
    "UPLOADED": "Caricato"
  },
  "submitModal": {
    "composition": "Composizione",
    "confidenceStatement": "Confermo solennemente che le informazioni fornite sono corrette e complete",
    "confirmation_one": "{{count}} richiesta di tracciabilità inviata con successo",
    "confirmation_many": "confirmation",
    "confirmation_other": "{{count}} richieste di tracciabilità inviate con successo",
    "error": "errore",
    "noRequests": "Non hai richieste complete da inviare su questa pagina",
    "reference": "Riferimento",
    "submitButton": "Conferma ({{ itemCount }})",
    "title": "Seleziona tutte le richieste che desideri inviare",
    "type": "Tipo"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "productionSite",
      "status": "Stato",
      "tags": "Tag"
    }
  },
  "tooltips": {
    "contact": "Persona responsabile dell'informazione fornita.",
    "productionSite": "Un sito registrato nel tuo repository dove si svolgono le operazioni di produzione o di trasformazione. Ogni sito è generalmente associato a un solo flusso di produzione, a meno che non sia integrato con più operazioni.",
    "purchaseOrderRef": "Se non hai un ordine d'acquisto per questo {{type}}, puoi fornire un numero di fattura",
    "reference": "Riferimento per identificare l'articolo per il tuo fornitore"
  },
  "transferModal": {
    "success": "Richiesta di certificato trasferita con successo",
    "title": "Seleziona il contatto al quale trasferire il certificato"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Fornitore di Accessori",
    "accessoryRawMaterialProvider": "Fornitore di Materie Prime",
    "apparel": {
      "duvet": {
        "baffle": "Bordo",
        "farm": "Fattoria (piumino)",
        "materialProduction": "Materia prima (piumino)",
        "preProcessor": "Pre-Processore"
      },
      "fabric": {
        "appret": "Finitura (tessuto)",
        "coating": "Rivestimento (tessuto)",
        "dyeing": "Tintura/Stampa (tessuto)",
        "lamination": "Laminazione",
        "materialProduction": "Materia prima (tessuto)",
        "spinning": "Filatura (tessuto)",
        "weavingKnitting": "Tessitura/Maglieria"
      },
      "leather": {
        "appret": "Finitura (pelle)",
        "dyeing": "Tintura (pelle)",
        "farm": "Fattoria (pelle)",
        "materialProduction": "Macello",
        "tanning": "Conciatura pelle"
      },
      "manufacturing": "Produzione abbigliamento",
      "yarn": {
        "dyeing": "Tintura (filo)",
        "materialProduction": "Materia prima (filo)",
        "spinning": "Filatura (filo)"
      }
    },
    "brand": "marca",
    "certifiedEntity": "entità certificata",
    "footwear": {
      "assembling": "Assemblaggio",
      "finishing": "Finitura",
      "stitching": "Cucitura"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Assemblaggio carta",
      "bleaching": "Sbiancamento",
      "chemicalTreatment": "Trattamento chimico",
      "laminating": "Laminazione",
      "manufacturing": "Produzione carta",
      "pressing": "Pressatura",
      "printing": "Stampa",
      "resineRemoving": "Rimozione resina",
      "whiteWashing": "Lavaggio in bianco"
    },
    "product": {
      "productWashing": "Lavaggio prodotto",
      "washing": "Lavaggio"
    },
    "wood": {
      "assembling": "Assemblaggio legno",
      "brushing": "Spazzolatura",
      "calibrationAndCollage": "Calibrazione e collage",
      "harvesting": "Raccolta",
      "manufacturing": "Produzione legno",
      "materialDrying": "Essiccazione",
      "materialPeeking": "Selezione",
      "materialPeeling": "Pelatura",
      "materialSawing": "Taglio",
      "sanding": "Levigatura"
    }
  }
}
